import "./bootstrap";

/*
|--------------------------------------------------------------------------
| importするプラグインなど
|--------------------------------------------------------------------------|
*/
import axios from "@/axios";
import router from "@/router/index.js";
import VueDatePicker from "@vuepic/vue-datepicker";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import PrimeVue from "primevue/config";
import { createApp } from "vue";
import VueCookies from "vue-cookies";
import Vue3TagsInput from "vue3-tags-input";
import App from "./components/pages/App.vue";

// Vuetify
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
// import "vuetify/styles";

const vuetify = createVuetify({
	components,
	directives
});

/*
|--------------------------------------------------------------------------
| importするcss
|--------------------------------------------------------------------------|
*/

// VSonnerで使用（アイコン表示用）
import "@mdi/font/css/materialdesignicons.css";
import "@vuepic/vue-datepicker/dist/main.css";

/*
|--------------------------------------------------------------------------
| mount処理
|--------------------------------------------------------------------------|
*/
const app = createApp(App);
app.config.globalProperties.$axios = axios;
app.use(router);
app.use(vuetify);
app.use(PrimeVue);
app.use(Vue3TagsInput);
app.use(VueCookies);
app.component("vue-date-picker", VueDatePicker);

/*
|--------------------------------------------------------------------------
| カスタムディレクティブ
|--------------------------------------------------------------------------|
*/

// カスタムディレクティブの定義（モーダルの外をクリック）
app.directive("click-outside", {
	// ディレクティブが初めて紐づいたときの処理
	mounted(el, binding) {
		// elはディレクティブが紐づいた要素
		// binding.valueにはv-click-outside="value or method"で指定した値が入る
		el.clickOutsideEvent = function (event) {
			// Check if the click was outside the element and its children
			if (!(el === event.target || el.contains(event.target))) {
				// ディレクティブに渡された値、またはmethodが呼び出される
				binding.value(event);
			}
		};
		document.body.addEventListener("click", el.clickOutsideEvent);
	},
	// ディレクティブが紐づいている要素から取り除かれたときの処理
	unmounted(el) {
		document.body.removeEventListener("click", el.clickOutsideEvent);
	}
});

app.use(createPinia().use(piniaPluginPersistedstate));
app.mount("#app");
